<template>
  <div class="statusPage">
    <div class="pageTop">
      <h1>设备销售状态</h1>
      <h2>景区选择</h2>
      <SearchSelect
        className="longSelect"
        v-model="store"
        :options="storeOptions"
        :props="{
          label: 'label',
          value: 'value',
        }"
        placeholder="请选择景区"
      />

      <el-button @click="handleQuery">查询</el-button>
      <el-button size="small" @click="handleDownload" icon="el-icon-download"
        >下载</el-button
      >
    </div>

    <div class="deviceBox">
      <div class="leftBox">
        <template v-if="salesStatusList && salesStatusList.length > 0">
          <ul>
            <li v-for="item in displayedDataRight.slice(0,10)" :key="item.id">
              <p>{{ item.name }}</p>
              <template v-if="typeof item.time === 'number'">
                <p v-if="item.time > 0">连续{{ item.time }}天无销售额</p>
                <p v-else>历史无销售记录</p>
              </template>
              <template v-else>
                <p>{{ item.time }}</p>
              </template>
            </li>
          </ul>
        </template>
        <div v-else class="noData">暂无数据...</div>
      </div>
      <div class="rightBox">
        <template v-if="salesStatusList && salesStatusList.length > 0">
          <ul>
            <li v-for="item in displayedDataRight.slice(10,20)" :key="item.id">
              <p>{{ item.name }}</p>
              <template v-if="typeof item.time === 'number'">
                <p v-if="item.time > 0">连续{{ item.time }}天无销售额</p>
                <p v-else>历史无销售记录</p>
              </template>
              <template v-else>
                <p>{{ item.time }}</p>
              </template>
            </li>
          </ul>
        </template>

        <div v-else class="noData">暂无数据...</div>
      </div>
    </div>
      <!-- 分页器 -->
      <el-pagination
            background
            :layout="layout"
            @current-change="handleCurrentChangeRight"
            :current-page="currentPageRight"
            :page-size="pageSize"
            :total="salesStatusList.length"
          />
  </div>
</template>

<script>
import SearchSelect from "@/views/components/SearchSelect";
import {
  getDeviceSaleDownload,
  getSaleOffline,
} from "@/api/bi";

export default {
  name: "DeviceStatus",
  data() {
    return {
      store: "",
      category: ["1", "2", "3","4","5","6","7","8"],
      options: [
        { value: "1", label: "771/772" },
        { value: "2", label: "775" },
        { value: "3", label: "776" },
        { value: "4", label: "779" },
        { value: "5", label: "780" },
        { value: "6", label: "781" },
        { value: "7", label: "782" },
        { value: "8", label: "783" }
      ],
      offlineList: [], // 离线设备
      salesStatusList: [], // 设备销售状态
      currentPage: 1, // 当前页码
      currentPageRight: 1, // 当前页码
      pageSize: 20, // 每页显示条数
      layout: "total,  prev, pager, next, jumper", // 分页数据
    };
  },
  props: ["allStore"], // 全部景区列表
  beforeMount() {
    // this.getData();
    this.getSalesList();
  },
  methods: {
    // 清除el-select搜索文本框的值query
    onSelectChange() {
      this.$refs["el-select3"].query = "";
    },
    handleQuery() {
      // 查询
      // 页码重置为1
      this.currentPage = 1; // 当前页码
      this.currentPageRight = 1;
      // this.getData();
      this.getSalesList();
    },
    getData(val) {
      if (val === "manual") {
        this.currentPage = 1;
      }
      // 请求参数
      const params = {
        source: [...this.category], // 业务分类
        company_id_list: [...this.store], // 景区列表
        // company_id_list: ['cad7d66f2e6bec50'] // 景区列表
      };
      getDeviceSaleDownload(params).then((res) => {
        this.offlineList = [];
        if (res && res.code === 2000 && res.data) {
          if (res.data.constructor.name === "Array") {
            res.data.map((val) => {
              this.offlineList.push({
                name: val.device_name,
                time: val.time,
                id: val.device_id,
              });
            });
          }
        }
      });
    },
    getSalesList() {
      const params = {
        source: [...this.category], // 业务分类
        company_id_list: [...this.store], // 景区列表
      };
      getSaleOffline(params).then((res) => {
        this.salesStatusList = [];
        if (res && res.code === 2000 && res.data) {
          if (res.data.constructor.name === "Array") {
            res.data.map((val) => {
              this.salesStatusList.push({
                name: val.device_name,
                time: val.time,
                id: val.device_id,
              });
            });
          }
        }
      });
    },
    handleSelect(val) {
      // 接收来自组件的数据
      this.store = val;
    },
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 处理当前页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 处理当前页码变化
    handleCurrentChangeRight(val) {
      this.currentPageRight = val;
    },
    handleDownload() {
      this.$confirm(`确认下载销售状态数据吗？`).then(() => {
        // 下载
        // 请求参数
        const params = {
          source: [...this.category], // 业务分类
          company_id_list: [...this.store], // 景区列表
          // company_id_list: ['cad7d66f2e6bec50'] // 景区列表
        };
        getDeviceSaleDownload(params)
          .then((data) => {
            this.download(data);
          })
          .catch((error) => {
            this.$message.error(error);
          });
      });
    },
    download(resp) {
      const fileName = "设备销售状态";
      const blob = new Blob([resp.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },
  },
  components: {
    SearchSelect,
  },
  computed: {
    storeOptions() {
      let arr = [];
      if (!Array.isArray(this.allStore)) return arr;
      this.allStore.map((val) => {
        arr.push({ label: val.name, value: val.id });
      });
      return arr;
    },
    // 计算属性，根据当前页和每页条数获取当前显示的数据
    displayedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      if (this.offlineList && this.offlineList.length > 0) {
        return this.offlineList.slice(start, end);
      } else {
        return [];
      }
    },
    displayedDataRight() {
      const start = (this.currentPageRight - 1) * this.pageSize;
      const end = start + this.pageSize;
      if (this.salesStatusList && this.salesStatusList.length > 0) {
        return this.salesStatusList.slice(start, end);
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}

/* 改变滚动条的轨道宽度和颜色 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}

.pageTop {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.pageTop h1 {
  margin-right: 30px;
  font-size: 22px;
  font-weight: bold;
}

.pageTop h2 {
  margin-right: 10px;
}

.pageTop .mineSelect {
  margin: 0 30px;
}

.statusPage,
.deviceBox {
  font-size: 16px;
  color: #ffffff;
  padding: 20px;
  /* border: 1px solid #5c01b8; */
  border-radius: 30px;
  width: 95%;
  margin: 10px auto;
}

.statusPage {
  box-shadow: 0 0 10px;
  /*border-color: #58D9F9;*/
}

.statusPage .el-button {
  margin-left: 10px;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.title h2 {
  margin-right: 20px;
  font-size: 20px;
}

@media (max-width: 1400px) {
  .leftBox,
  .rightBox {
    width: 80%;
  }
}

@media (min-width: 1400px) {
  .deviceBox {
    display: flex;
    /* justify-content: space-around; */
  }

  .leftBox,
  .rightBox {
    width: 50%;
  }
}

.leftBox ul,
.rightBox ul {
  /*height: 300px;*/
  /*overflow-y: scroll;*/
  margin-top: 10px;
  padding: 0 5%;
}

.leftBox li,
.rightBox li {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.rightBox h2 {
  height: 32px;
  line-height: 32px;
  text-align: center;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;
}

.noData {
  text-align: center;
  margin-top: 30px;
}
</style>

<style>
.statusPage .el-pagination {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 50px;
  color: #ffffff;
}

.statusPage .el-pagination__jump,
.statusPage .el-pagination__total {
  color: #ffffff;
}
</style>